export * from './IconFolderContour';
